import './App.css';

import { useRoutes } from 'react-router-dom';
import Themeroutes from "./route/Router";

function App() {
  const routing = useRoutes(Themeroutes);
   return (
     <div className="app">{routing}</div>
   )
}

export default App;
